import { deviceModels, deviceTypes } from "src/helper/constants"
import { dockConnectionManager } from "src/helper/HubConnectionManager";
import store from "src/redux/configureStore"
import { djiCloudMethod } from "src/services/common/constants";

export const getDeviceModelInfo = (model, subModel) => {
  let realModel, realSubModel, modelInfo;

  if (model?.indexOf?.('-') > -1) {
    const modelParts = model.split('-');

    if (modelParts?.length === 2)
      [realModel, realSubModel] = modelParts;
    else if(modelParts?.length === 3)
      [, realModel, realSubModel] = modelParts;
  }
  else if (subModel === undefined) {
    modelInfo = deviceModels.find(item => item.model === model);
  }

  if (!modelInfo) {
    realModel = parseInt(model);
    realSubModel = subModel !== undefined && parseInt(subModel);

    modelInfo = deviceModels.find(item => {
      return item.model === realModel && (realSubModel === undefined || item.subModel === realSubModel);
    })
  }

  if (!modelInfo) return null;

  modelInfo = {
    ...modelInfo,
    modelNumber: realModel ?? modelInfo.modelNumber,
    subModelNumber: realSubModel ?? modelInfo.subModelNumber,
  };

  return modelInfo;
}

export const getDeviceTelemetries = (deviceId) => {
  return store.getState().deviceService.deviceTelemetries[deviceId];
}

export const getSubDeviceTelemetries = (deviceId) => {
  const deviceTelemetries = getDeviceTelemetries(deviceId);

  if(deviceTelemetries?.sub_device?.device_sn)
    return getDeviceTelemetries(deviceTelemetries.sub_device.device_sn);
  else return null;
}

export const getDeviceHms = (deviceId) => {
  return store.getState().deviceService.deviceHms[deviceId];
}

export const getSubDeviceHms = (deviceId) => {
  const deviceTelemetries = getDeviceTelemetries(deviceId);

  if(deviceTelemetries?.sub_device?.device_sn)
    return getDeviceHms(deviceTelemetries.sub_device.device_sn);
  else return null;
}

export const getDeviceConnectionGroups = (deviceId) => {
  const state = store.getState();
  const deviceType = state.deviceService.devices.find(device => device.id === deviceId)?.type;

  if (deviceType === deviceTypes.DOCK) {
    return state.deviceService.dockConnections.find(connection => connection.deviceId === deviceId)?.group;
  }
  else if (deviceType === deviceTypes.DRONE) {
    return state.deviceService.onboardConnections.find(connection => connection.deviceId === deviceId)?.group;
  }
  else return null;
}

export const getDeviceInfo = (deviceIdOrSerial, type) => {
  return store.getState().deviceService.devices?.find(item => (item.id === deviceIdOrSerial || item.serialNumber === deviceIdOrSerial) && (!type || item.type === type));
}

export const getDeviceCoordinates = (deviceId) => {
  const deviceTelemetries = getDeviceTelemetries(deviceId);
  const latitude = deviceTelemetries?.latitude || deviceTelemetries?.gps?.lat;
  const longitude = deviceTelemetries?.longitude || deviceTelemetries?.gps?.long;

  if(latitude && longitude)
    return {
      lat: latitude,
      long: longitude,
    }
  else return null;
}


export const getDeviceAuthorityInfo = (deviceId,) => {
  return store.getState().deviceService.deviceFlightAuthorityStatus?.[deviceId];
}

export const getSubDeviceInfo = (deviceId) => {
  const deviceTelemetries = getDeviceTelemetries(deviceId);

  if(deviceTelemetries?.sub_device?.device_sn)
    return getDeviceInfo(deviceTelemetries.sub_device.device_sn);
}

export const sendAsyncDjiCloudRequest = async (deviceId, reqChannel, resChannel, method, data = null) => {
  return new Promise((resolve, reject) => {
    const connectionGroups = getDeviceConnectionGroups(deviceId);

    const {bid: requestBid} = dockConnectionManager.sendToDjiCloudGroup(deviceId, connectionGroups?.send?.[reqChannel], {
      method,
      data,
    });

    const timeoutId = setTimeout(() => {
      reject(new Error('🛑 Dji cloud async request timed out'));
    }, 5000);

    dockConnectionManager.subscribeGroupMessages([
      {
        identity: deviceId,
        name: [connectionGroups?.join?.[resChannel]],
        handler: (message) => {
          if(message?.method === method && message?.bid === requestBid) {
            if(message.data?.result === 0) {
              resolve(message);
            }
            else {
              reject(message);
            }

            clearTimeout(timeoutId);
          }
        }
      },
    ], 'device-utils');
  });
}

export const sendUpdateFlightAreasRequest = async (dockId) => {
  return sendAsyncDjiCloudRequest(dockId, 'services', 'services_reply', djiCloudMethod.customFlightArea.FLIGHT_AREAS_UPDATE, null);
}